import React from "react";
import { IonButton, IonSelect, IonSelectOption } from "@ionic/react";
import { Message } from "../../interfaces";

interface Props {
  message: Message;
  type?: "conversation" | "playground" | "web-chat" | string;
  actionClick?: Function;
}

const InteractiveActions: React.FC<Props> = ({
  message,
  type,
  actionClick,
}) => {
  const { interactive } = message;
  const { flag, data } = interactive;

  if (!flag || !data) return null;

  const buttons = data.buttons || [];
  const lists = data.list || [];

  if (lists.length > 0 && lists[0].rows) {
    return (
      <div className="chat-actions mt-2">
        <div className="chat-select-wrapper">
          <div className="chat-select-options">
            <IonSelect
              aria-label="options"
              placeholder="Options"
              interface="popover"
            >
              {lists[0].rows.map((item, i) => (
                <IonSelectOption
                  key={i}
                  value={i}
                  onClick={() => {
                    actionClick?.({ message, text: item.title });
                  }}
                >
                  {item.title}
                </IonSelectOption>
              ))}
            </IonSelect>
          </div>
        </div>
      </div>
    );
  }

  if (buttons.length > 0) {
    return (
      <div className="chat-actions">
        {buttons.map((button, i) => (
          <IonButton
            key={i}
            expand="block"
            color="light"
            size="small"
            mode="ios"
            disabled={type === "conversation"}
            onClick={() => {
              actionClick?.({ message, text: button.title });
            }}
            className="mt-1"
          >
            {button.title}
          </IonButton>
        ))}
      </div>
    );
  }

  return null;
};

export default InteractiveActions;
